<div class="widget container p-3 ruleChainDetails flex flex-column">
  <div class="flex justify-content-between">
    <app-svg-icon iconName="arrow_left" iconColor="primary" iconSize="sm" (click)="goBack()"></app-svg-icon>
  </div>

  @if (ruleChainDetails()) {
    <p-table
      [value]="ruleChainDetails()?.definitions ?? []"
      [columns]="definitionsColumns"
      dataKey="id"
      editMode="row"
      [editingRowKeys]="editingRowKeys"
      class="mb-4 p-3 tableHeaderAlignTop"
    >
      <ng-template #caption>
        <div class="flex justify-content-between w-full">
          <span>
            {{ "butler_programming.definitions.title" | translate }}
          </span>
          <app-svg-icon iconName="plus" iconColor="primary" class="pointer" (click)="addDefinition()"></app-svg-icon>
        </div>
      </ng-template>
      <ng-template #header let-columns>
        <tr>
          @for (col of columns; track col) {
            <th>{{ col.header | translate }}</th>
          }
          <th></th>
          <th></th>
        </tr>
      </ng-template>
      <ng-template #body let-definitionRow let-columns="columns" let-editing="editing" let-rowIndex="rowIndex">
        <tr [pEditableRow]="definitionRow">
          <!-- Label cell:  -->
          <td>
            <p-cellEditor>
              <ng-template #input>
                <input pInputText type="text" [(ngModel)]="definitionRow.label" />
              </ng-template>
              <ng-template #output>
                {{ definitionRow.label }}
              </ng-template>
            </p-cellEditor>
          </td>
          <!-- Type cell:  -->
          <td>
            <p-cellEditor>
              <ng-template #input>
                <p-select
                  [options]="typeOptions()"
                  appendTo="body"
                  (onChange)="onChangeDefType(definitionRow)"
                  [(ngModel)]="definitionRow.type"
                >
                  <ng-template #selectedItem>
                    {{ "butler_programming.definitions.typeOptions." + definitionRow.type | translate }}
                  </ng-template>
                  <ng-template let-type #item>
                    {{ type.label | translate }}
                  </ng-template>
                </p-select>
              </ng-template>
              <ng-template #output>
                {{ "butler_programming.definitions.typeOptions." + definitionRow.type | translate }}
              </ng-template>
            </p-cellEditor>
          </td>

          <!-- Gate system cell:  -->
          <td>
            <p-cellEditor>
              <ng-template #input>
                @if (definitionRow.type === "Input" || definitionRow.type === "Relais") {
                  <p-select [options]="gateSystems()" appendTo="body" [(ngModel)]="definitionRow.gateSystem" />
                }
              </ng-template>
              <ng-template #output>
                {{ definitionRow.gateSystem?.label }}
              </ng-template>
            </p-cellEditor>
          </td>

          <!-- Value cell:  -->
          <td>
            <p-cellEditor>
              <ng-template #input>
                @if (definitionRow.type === "Input" || definitionRow.type === "Relais") {
                  <p-select
                    [options]="valueOptions()[definitionRow.type]"
                    appendTo="body"
                    [(ngModel)]="definitionRow.value"
                  />
                } @else if (definitionRow.type === "Timer") {
                  <p-inputNumber [(ngModel)]="definitionRow.value" />
                }
              </ng-template>
              <ng-template #output>
                @if (definitionRow.type !== "Flag") {
                  {{ definitionRow.value }}
                }
              </ng-template>
            </p-cellEditor>
          </td>

          @if (!editing) {
            <td>
              <app-svg-icon
                iconName="edit"
                iconColor="primary"
                class="pointer"
                pInitEditableRow
                (click)="onRowEditInit(definitionRow)"
              >
              </app-svg-icon>
            </td>
            <td>
              <app-svg-icon
                iconName="trash"
                iconColor="primary"
                class="pointer"
                (click)="onRowDelete(definitionRow)"
              ></app-svg-icon>
            </td>
          }

          @if (editing) {
            <td>
              <app-svg-icon
                iconName="check"
                iconColor="primary"
                class="pointer"
                pSaveEditableRow
                (click)="onRowEditSave(definitionRow)"
              ></app-svg-icon>
            </td>
            <td>
              <app-svg-icon
                iconName="x"
                iconColor="primary"
                pCancelEditableRow
                class="pointer"
                (click)="onRowEditCancel(definitionRow)"
              ></app-svg-icon>
            </td>
          }
        </tr>
      </ng-template>
    </p-table>
  }
  <app-instruction-table [instruction]="firstInstruction" [definitions]="definitions"></app-instruction-table>
</div>
